import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { useAuthStore } from '@/stores/authStore';
import { useKycStore } from '@/stores/kycStore';
import { useConfigStore } from '../stores/configStore';
import { useCustomerStore } from '../stores/customerStore';
import { useLeadStore } from '../stores/leadStore';
import _ from 'lodash';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

function checkAccessCodes(current_user_access, route_required_access){
	if(!current_user_access) return false;

	let intersect = _.intersection(current_user_access,route_required_access);
	return (intersect.length > 0);
}

function checkAppCode(app_code){
  const configStore = useConfigStore()  
  return configStore.app_code.includes(app_code)
}

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()  
  const kycStore = useKycStore()  
  const configStore = useConfigStore()  
  const customerStore = useCustomerStore() 
  const leadStore = useLeadStore()
	console.log(to)
	if(to.meta.publicAuth){
		if(_gHlp.isEmpty(to.query.payload)) {
			next({name: 'Login'});
		}

		let queryObj = JSON.parse(atob(to.query.payload));

		let email = _gHlp.getValue(queryObj,'email')
		let public_code= _gHlp.getValue(queryObj,'public_code')
		let app_code= _gHlp.getValue(queryObj,'app_code')
		let data= _gHlp.getValue(queryObj,'data')
		// let message_profile: 'messaging_l_83767'
		window.localStorage.setItem('app_code',app_code);
		await authStore.loginToken(email,public_code)

		if(!authStore.auth_user){
			alert("Access token invalid. Proceed login.")
			next({name: 'Login'});
		}
		console.log("AFTER LOGIN")
		console.log(to);
		next()
	}else{
		// check if route requires auth
		if (to.meta.requiresAuth){
				// check if route has token params
				if(to.params.token){
					await authStore.fetchUserInfo(to.params.token);

					// if no user redirect to login
					if(!authStore.auth_user){
						alert("Access token invalid. Proceed login.")
						next({name: 'Login'});
					}

					next()
				}

				if (from.fullPath.includes('customerProfile') && !to.fullPath.includes('customerProfile') ) {
					customerStore.filter_query = {}
				}

				if (from.fullPath.includes('lead') && !to.fullPath.includes('lead') ) {
					leadStore.filter_query = {}
				}

				// fetch user info if has no user but got token
				if(!authStore.auth_user && localStorage.getItem("auth_user") !== null){
					await authStore.fetchUserInfo()
				}

				if( !kycStore.kyc_user && localStorage.getItem("kyc_user") !== null){
					await kycStore.fetchUserInfo()
				}

				// if no user redirect to login
				if(!authStore.auth_user){
					next({name: 'Login'})
				}

				// check if account invalid
				if(authStore.auth_user && authStore.auth_user.account_info.application_code != configStore.app_code){
					next({name: 'InvalidAccount'})
					return
				}

				// check if subscription ended
				if(authStore.auth_user && authStore.auth_user.subscription.scrb_status !== 'ACTIVE'){
					next({name: 'SubscriptionEnded'})
					return
				}

				// check if path requires manager role
				if(to.meta.requiresManager){
					let has_role = false
					if(['admin','director','manager'].includes(authStore.auth_user.account_info.role_type)) {
						has_role = true;
					}

					if(has_role){
						next()
					}else{
						next({name: 'Home'});
					}
				}

				// check if path requires role access
				let orCondition = (to.meta.requiresOrAccessCodes) ?  checkAccessCodes(authStore.auth_user.access_codes,to.meta.requiresOrAccessCodes) : false;
				if(to.meta.requiresAccessCodes){
					if(checkAccessCodes(authStore.auth_user.access_codes,to.meta.requiresAccessCodes) || orCondition){
						next()
					}else{
						next({name: 'Home'});
					}
				}
			
				// check if path requires subscription
				if(to.meta.requiresSubcription){
					const package_name = to.meta.requiresSubcription
					if(authStore.auth_user.subscription.privileges[package_name]){
						next()
					}else{
						next({name: 'Home'});
					}
				}

				// check if path requires role type
				if(to.meta.requiresRoleType){
					const role_types = to.meta.requiresRoleType
					if(role_types.includes(authStore.auth_user.account_info.role_type) || orCondition){
						next()
					}else{
						next({name: 'Home'});
					}
				}

				// check if path requires app code
				if(to.meta.requiresAppCode){
					const appCodes = to.meta.requiresAppCode
					let found = false
					appCodes.forEach(code => {
						if(authStore.auth_user.account_info.application_code.includes(code)){
							found = true
						}
					})
					if(found || orCondition){
						next()
					}else{
						next({name: 'Home'});
					}
				}      

				// check if require to be owner of the subscriber
				if(to.meta.requiresSubscriptionOwner){
					const is_owner = authStore.auth_user.subscription.scrb_is_my_own
					if(is_owner){
						next()
					}else{
						next({name: 'Home'});
					}
				}

				next()
		}
		
		// fetch user info if has no user but got token - for page reload
		if(!authStore.auth_user && localStorage.getItem("auth_user") !== null){
			await authStore.fetchUserInfo()
		}

		if( !kycStore.auth_user && localStorage.getItem("kyc_user") !== null){
			await kycStore.fetchUserInfo()
		}

		// redirect to setup page if from login
		if(authStore.auth_user && to.path === '/login'){
			next({name: 'Customer'});
		}

		// redirect to home if from subscription ended page
		if(authStore.auth_user && authStore.auth_user.subscription.scrb_status === 'ACTIVE' && to.name === 'SubscriptionEnded'){
			next({name: 'Home'});
		}  

		// redirect to home if from invalid account page
		if(authStore.auth_user && authStore.auth_user.account_info.application_code == configStore.app_code && to.name === 'InvalidAccount'){
			next({name: 'Home'});
		}  
  }  

  next()
})



export default router;
